const isLive = process.env.REACT_APP_ENVIRONMENT === "PRODUCTION";
console.log('ENV VAR:', process.env.REACT_APP_ENVIRONMENT);
const SDK = {
 
  SOCKET_URL: "https://ios.minimis.cloud",
  // STRIPE_KEY:
  // "pk_live_51Mq48pCHhPy4gmdpHje6ECXZRh9uYTmYFVm6sT3spEPtpwDWDBxDQRLe2dny342Mi3zRms5yHvOvhl9lbYrNb8Xu00np6bOu70",
  // STRIPE_KEY:
  //   "pk_test_51Mq48pCHhPy4gmdpAZQj1yYXf95jzpl3KfzkyjlR0ycFQRPB5GkG1TBXhoC0dRJK4IdrvKO2MGp6vtXGCvM3ZObr004SL3pW7o",
  STRIPE_KEY: isLive
    ? process.env.REACT_APP_STRIPE_KEY_LIVE
    : process.env.REACT_APP_STRIPE_KEY_TEST,

  FB_PIXEL_ID: process.env.REACT_APP_FB_PIXEL_ID,
  TIK_TOK_PIXEL_ID: process.env.REACT_APP_TIK_TOK_PIXEL_ID,
  X_PIXEL_ID: process.env.REACT_APP_X_PIXEL_ID,
  PAGE_TYPE: process.env.REACT_APP_PAGE_TYPE,
  FB_CURRNECY: process.env.REACT_APP_FB_CURRNECY,
  FB_PRICE: process.env.REACT_APP_FB_PRICE,
  FB_DISOUNT_PRICE: process.env.REACT_APP_FB_DISOUNT_PRICE,
  APPLE_PAY_PRICE: process.env.REACT_APP_APPLE_PAY_PRICE,
  APPLE_PAY_CURRENCY: process.env.REACT_APP_APPLE_PAY_CURRENCY,
  REGION_CONFIG: {
    uk: {
      currency: "gbp",
      price: 4999,
      countryCode: "GB",
      currSymbol: "£",
      text: "",
    },
    eu: {
      currency: "eur",
      price: 4999,
      countryCode: "DE",
      currSymbol: "€",
      text: "",
    },
    us: {
      currency: "usd",
      price: 4999,
      countryCode: "US",
      currSymbol: "$",
      text: " Prices are in USD.",
    },
  },
  getBaseUrl(pageType = "") {
    if (isLive) {
      if (pageType === "subscription") {
        return process.env.REACT_APP_SUB_BASE_URL;
      }
      if (pageType === "lifetime") {
        return process.env.REACT_APP_LIFE_BASE_URL;
      }
    return process.env.REACT_APP_LIFE_BASE_URL;
    } else {
      if (pageType === "subscription") {
        return process.env.REACT_APP_BASE_URL_DEV_SUBSCRIPTION;
      }
      if (pageType === "lifetime") {
        return process.env.REACT_APP_BASE_URL_DEV_LIFE;
      }
      return process.env.REACT_APP_BASE_URL_DEV_LIFE;
    }
  },
  getSelectedPlan(){
  const planData = localStorage.getItem("selectedPlan");
  if (!planData) return null;
  try {
    return JSON.parse(planData);
  } catch (error) {
    console.error("Error parsing selectedPlan from localStorage:", error);
    return null;
  }
},
  setSelectedPlan(plan) {
    if (!plan) return;
    try {
      localStorage.setItem("selectedPlan", JSON.stringify(plan));
    } catch (error) {
      console.error("Failed to save selectedPlan to localStorage:", error);
    }
  },
  clearAllLocalStorage() {
  try {
    localStorage.clear();
    console.log("All localStorage items removed.");
  } catch (error) {
    console.error("Error clearing localStorage:", error);
  }
}

};

export default SDK;
